import { get } from 'lodash';

import { connectToAuth } from '@zapier/common-utils';

// TODO: Remove all of this legacy code ASAP.
import z from 'app/common/z';
import Errors, { resourceNames } from 'app/errors';
import { addTruthyParamsToUrl } from 'app/common/utils/UrlUtils';
import { fetchJson } from 'app/common/fetch';

const baseApi = z.cfg.api;

const baseUrl = () => `${baseApi}/auths`;
const collectionUrl = (
  accountId,
  { shouldIncludeDestinationAuths = false } = {}
) =>
  addTruthyParamsToUrl(baseUrl(), {
    account_id: accountId,
    include_destination_selected_api: shouldIncludeDestinationAuths,
  });
const modelUrl = id =>
  addTruthyParamsToUrl(`${collectionUrl()}/${id}`, {
    include_destination_selected_api: true,
  });
const testUrl = id =>
  addTruthyParamsToUrl(`${collectionUrl()}/${id}/test`, {
    include_destination_selected_api: true,
  });

const Data = {
  auths(accountId, params = {}) {
    return fetchJson(collectionUrl(accountId, params)).then(
      ({ objects }) => objects
    );
  },

  auth(id) {
    return fetchJson(modelUrl(id)).then(response => {
      if (!get(response, 'id')) {
        throw new Error('error reconnecting auth, no id in response');
      }
      return response;
    });
  },

  connectAuth(params) {
    return connectToAuth(params);
  },

  reconnectAuth(params, oldId) {
    return connectToAuth({ ...params, authId: oldId }).then(() => oldId);
  },

  updateAuth(attrs) {
    return fetchJson(modelUrl(attrs.id), {
      method: 'put',
      body: JSON.stringify(attrs),
    }).catch(response => {
      throw new Errors.DataPutError({ resource: resourceNames.auth, response });
    });
  },

  deleteAuth(id) {
    return fetchJson(modelUrl(id), {
      method: 'delete',
    });
  },

  testAuth(id) {
    return fetchJson(testUrl(id), {
      method: 'post',
    }).catch(response => {
      throw new Errors.DataPostError({
        resource: resourceNames.authTest,
        response,
      });
    });
  },

  loadAuthCounts() {
    return fetchJson(`${z.cfg.api}/auths/zaps`)
      .catch(response => {
        throw new Errors.DataGetError({
          resource: resourceNames.authUsage,
          response,
        });
      })
      .then(data => data.objects);
  },
};

export default Data;
